const ASSETS = 'https://evwixwbrpysyzeehoedy.supabase.co/storage/v1/object/public/carpepel-assets';

/**
 * Reescribe una URL del bucket de Supabase para que se pida a NUESTRO
 * servidor (/img/...) en vez de directamente al bucket.
 *
 * Por qué: Supabase devolvía estas fotos con `cache-control: no-cache`.
 * Medido sobre el catálogo real: 40 imágenes, 4.7 MB, ninguna cacheable —
 * cada visita las volvía a bajar completas. Y `cacheControl` es metadata que
 * se fija al subir cada objeto; el panel de Supabase ni siquiera la expone,
 * así que no había forma de corregirlo en el origen. El servidor (server.js)
 * las sirve con caché de 30 días y guarda una copia en memoria.
 *
 * Cualquier otra URL se devuelve intacta, así que esto es seguro de aplicar
 * a lo que venga del backend sin saber de antemano de dónde sale.
 */
const STORAGE_BASE = 'https://evwixwbrpysyzeehoedy.supabase.co/storage/v1/object/public/';
// Los mismos dos buckets que acepta el proxy del servidor. Son dos:
// `carpepel-assets` (fotos de marca y de catálogo cargadas a mano) y
// `product-images` (las que sube el admin desde el panel). La primera
// versión de esto solo cubría la primera, y en producción se vio que 5 de
// 13 productos seguían pidiendo su foto directamente a Supabase.
const CDN_BUCKETS = ['carpepel-assets', 'product-images'];

export function cdnUrl(url) {
    if (typeof url !== 'string' || !url.startsWith(STORAGE_BASE)) return url;
    const rest = url.slice(STORAGE_BASE.length);
    const slash = rest.indexOf('/');
    if (slash === -1) return url;
    const bucket = rest.slice(0, slash);
    const name = rest.slice(slash + 1);
    // Si el bucket no está en la lista, o el nombre no es un segmento plano
    // (una subcarpeta futura), la URL se deja intacta en vez de romperla.
    if (!CDN_BUCKETS.includes(bucket) || !/^[A-Za-z0-9._-]+$/.test(name)) return url;
    return `/img/${bucket}/${name}`;
}

/**
 * Fotos cuyo fondo se fundió al tono papel del sitio para que el producto
 * flote en la página en vez de vivir dentro de una caja blanca.
 *
 * NO están todas las del catálogo a propósito. El fundido solo es posible
 * cuando el fondo es neutro y claro Y el producto es de color saturado: así
 * se pueden separar sin dañar ninguno. De las 21 imágenes del catálogo, 14
 * son tomas de ambiente (mesa de madera, cocina, fondos de color) donde no
 * aplica, y una más (papel_cebolla_14lb) tiene una viñeta que baja a 197 de
 * luminancia, así que al fundirla se perdía la sombra y el paquete quedaba
 * pegado. Esas se muestran como lo que son: fotografías, dentro del mismo
 * marco sobrio que el resto.
 */
const FLOATING = {
    'papel_verde_v2.webp': 'float_papel_verde_v2.webp',
    'papel_canela_v2.webp': 'float_papel_canela_v2.webp',
    'papel_oro_v2.webp': 'float_papel_oro_v2.webp',
    'papel_mostaza_v2.webp': 'float_papel_mostaza_v2.webp',
    'papel_amarillo_v2.webp': 'float_papel_amarillo_v2.webp',
    'papel_cebolla_10_5lb.jpg': 'float_papel_cebolla_10_5lb.webp',
};

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/** Resuelve rutas relativas del backend a URL absoluta. */
export function resolveSrc(url) {
    if (!url) return null;
    return cdnUrl(url.startsWith('http') ? url : `${BACKEND_URL}${url}`);
}

/**
 * Devuelve la versión "flotante" si existe para esa imagen; si no, la
 * original. Nunca falla: el peor caso es una foto normal en su marco.
 */
export function productImage(url) {
    const src = resolveSrc(url);
    if (!src) return { src: null, floats: false };
    const file = src.split('/').pop().split('?')[0];
    const floated = FLOATING[file];
    return floated ? { src: cdnUrl(`${ASSETS}/${floated}`), floats: true } : { src, floats: false };
}
